export default __webpack_public_path__ + "static/social_ner-c812ac547d2b937e6ad7e86fa7978729.jpg";